import React from 'react';
import { Box, Button, IconButton, MenuItem, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { MAKS_BAGIAN, hitungBagi } from '../../utils/bagiBayar';

const rp = (v) => `Rp ${Math.round(Number(v) || 0).toLocaleString('id-ID')}`;

/**
 * Panel "Bagi Pembayaran" (tunai + non-tunai / beberapa non-tunai) untuk kasir web.
 * state = { non: [{ uuid, nominal }], tunai } ; onChange(stateBaru). Aturan: utils/bagiBayar.js (sama dengan server).
 */
const BagiBayarPanel = ({ total, nonCashMethods = [], state, onChange, disabled = false, sx }) => {
  const hasil = hitungBagi(total, state, nonCashMethods);
  const sisa = Math.max(0, total - hasil.totalNon);
  const ubahBaris = (i, perubahan) => onChange({ ...state, non: state.non.map((b, idx) => (idx === i ? { ...b, ...perubahan } : b)) });
  const sudahIsi = state.non.some((b) => b.uuid || b.nominal) || state.tunai;

  return (
    <Box sx={sx}>
      <Typography variant="body2" sx={{ color: '#6b778c', mb: 1 }}>
        Bagi tagihan {rp(total)} ke beberapa metode. Non-tunai tidak boleh melebihi tagihan; sisanya dibayar tunai.
      </Typography>
      {state.non.map((b, i) => (
        <Box key={i} sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'center' }}>
          <TextField
            select
            size="small"
            label="Metode non-tunai"
            value={b.uuid}
            onChange={(e) => ubahBaris(i, { uuid: e.target.value })}
            disabled={disabled}
            sx={{ flex: 5 }}
          >
            {nonCashMethods.length === 0 && <MenuItem value="" disabled>Belum ada metode, hubungi admin</MenuItem>}
            {nonCashMethods.map((m) => (
              <MenuItem key={m.uuid} value={m.uuid}>{m.name}</MenuItem>
            ))}
          </TextField>
          <TextField
            size="small"
            type="number"
            label="Nominal"
            value={b.nominal}
            onChange={(e) => ubahBaris(i, { nominal: e.target.value })}
            disabled={disabled}
            inputProps={{ min: 0 }}
            sx={{ flex: 4 }}
          />
          <IconButton
            size="small"
            aria-label="Hapus bagian"
            disabled={disabled || (state.non.length <= 1 && !state.tunai)}
            onClick={() => onChange({ ...state, non: state.non.filter((_, idx) => idx !== i) })}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
      {state.non.length < MAKS_BAGIAN - 1 && nonCashMethods.length > 0 && (
        <Button size="small" disabled={disabled} onClick={() => onChange({ ...state, non: [...state.non, { uuid: '', nominal: '' }] })} sx={{ mb: 1.5 }}>
          + Tambah metode non-tunai
        </Button>
      )}
      <TextField
        fullWidth
        size="small"
        type="number"
        label="Uang tunai diterima (kosongkan bila tanpa tunai)"
        value={state.tunai}
        onChange={(e) => onChange({ ...state, tunai: e.target.value })}
        disabled={disabled}
        inputProps={{ min: 0 }}
        sx={{ mb: 0.5 }}
      />
      <Box sx={{ textAlign: 'right', mb: 1 }}>
        <Button size="small" disabled={disabled || sisa <= 0} onClick={() => onChange({ ...state, tunai: String(Math.round(sisa)) })}>
          Uang pas: {rp(sisa)}
        </Button>
      </Box>
      <Box sx={{ p: 1.25, bgcolor: '#f0f2f5', borderRadius: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography variant="body2">Non-tunai</Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>{rp(hasil.totalNon)}</Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography variant="body2">Sisa dibayar tunai</Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>{rp(sisa)}</Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="body2">Kembalian</Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, color: '#16a34a' }}>{rp(hasil.kembalian)}</Typography>
        </Box>
      </Box>
      {hasil.galat && sudahIsi && (
        <Typography variant="body2" sx={{ color: '#dc2626', mt: 1 }}>{hasil.galat}</Typography>
      )}
    </Box>
  );
};

export default BagiBayarPanel;
